<template><div><h1 id="fakturen-avis-aufbereiten" tabindex="-1"><a class="header-anchor" href="#fakturen-avis-aufbereiten"><span>Fakturen/Avis aufbereiten</span></a></h1>
<p>Fakturen/Avis aufbereiten — Parameter und Protokoll für Faktura- und Avisjobs</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Pfad: <code v-pre>Verkauf → Verarbeitungsläufe → Fakturen/Avis verarbeiten → Fakturen/Avis aufbereiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobdatum/Laufnummer</dt>
<dd>Jobdatum und Laufnummer pro Datum</dd>
<dt>Aufbereitungsjob für:</dt>
<dd>Optionen:
<table>
<thead>
<tr>
<th>Auswahl</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Avis</td>
<td>Avisierung der Kunden bei Lieferverzug</td>
</tr>
<tr>
<td>Samm</td>
<td>Aufbereitung der Sammelrechnungen</td>
</tr>
<tr>
<td>WBS</td>
<td>Lieferscheine und Rechnungen aller Auftragsarten im System</td>
</tr>
</tbody>
</table>
</dd>
<dt>maximale Anzahl</dt>
<dd>Einschränkung auf maximale Anzahl Fakturen, die aufbereitet werden sollen</dd>
<dt>bis Datum</dt>
<dd>Einschränkung nach Verarbeitungsdatum im Auftragskopf (Standard: Erfassungsdatum)</dd>
<dt>Jobgruppe</dt>
<dd>Anzeige der Jobgruppe, zu welcher der Job gehört. Diese wird vom System vergeben, um verschiedene WBS-Aufbereitungsläufe in einer Bereitstellungsliste zusammenfassen zu können und um diese entsprechend auch gemeinsam drucken zu können</dd>
<dt>Aufbereitete WBS</dt>
<dd>Anzeige der Anzahl der Fakturen (Rechnungen, Lieferscheine, Geschenkbons, Avisierungen etc.), welche im jeweiligen Job bearbeitet wurden</dd>
<dt>Anzahl Durchgänge</dt>
<dd>Anzeige der Anzahl Durchgänge, welche der Job für die Aufbereitung der Daten benötigt hat</dd>
<dt>von/bis Fakturanummer</dt>
<dd>Anzeige der niedrigsten / höchsten Fakturanummer, die im Job verarbeitet wurde</dd>
<dt>Versandart</dt>
<dd>Angabe von bis zu neun Verarbeitungsarten aus Tabelle <a class="link" href="ft.refdata.tblverarb.html" title="Verarbeitungsarten">Verarbeitungsarten</a></dd>
<dt>Auftragsart</dt>
<dd>Einschränkung auf 1 <a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</a>, die aufbereitet werden soll.</dd>
<dt>Avisierung</dt>
<dd>Avisierung von Aufträgen, die schon die letzte <a class="link" href="ft.refdata.tblgeduld.html" title="Geduldstufen">Geduldstufe</a> erreicht haben oder nur Aufträge, die im aktuellen Lauf die Geduldstufe ändern.</dd>
<dt>Zahlungsarten</dt>
<dd>Es werden alle Zahlungsarten avisiert oder nur diejenigen mit der Zahlungsart &quot;Kreditkarte&quot; (= manuell erfasste Kreditkartenzahlungen).</dd>
<dt>nur von Auftraggeber</dt>
<dd>Einschränkung auf einen einzigen Auftraggeber.</dd>
<dt>mit Merkmal</dt>
<dd>Einschränkung auf Auftraggeber mit bestimmtem Merkmal</dd>
<dt>mit Artikel</dt>
<dd>Einschränkung auf Aufträge, die diesen Artikel beinhalten</dd>
<dt>Aufträge aufbereiten</dt>
<dd>Festlegung ob in Aufträgen, in denen dieser Artikel enthalten ist, nur dieser Artikel aufbereitet werden soll, oder alle Auftragspositionen des Auftrages.</dd>
<dt>LS-Druckdatum</dt>
<dd>Druckdatum des Direktlieferanten-Lieferscheins; wird vom System automatisch vergeben</dd>
<dt>LS-Druckdatei</dt>
<dd>Druckdatei des Direktlieferanten-Lieferscheins</dd>
<dt>LS-Drucker</dt>
<dd>Drucker für Direktlieferanten-Lieferscheine</dd>
<dt>Druckdatum</dt>
<dd>Anzeige des Datums, an dem der Job gedruckt wurde.</dd>
<dt>Druckdatei</dt>
<dd>Anzeige der für den Output gewählten Druckdatei (optional)</dd>
<dt>Druckername</dt>
<dd>Name des Druckers, auf den der Job ausgegeben werden soll. Bei der Angabe einer Druckdatei werden die für den angegebenen Drucker gültigen Initialisierungssteuerzeichen in die Datei geschrieben</dd>
<dt>Verarbeitungsstatus</dt>
<dd>Status des Aufbereitungsjobs:| Status | Beschreibung |
| --- | --- |
| 1 | Job-Parameter erfasst; noch nicht aufbereitet; löschbar |
| 2 | Aufbereitung angefangen (bzw. abgebrochen) |
| 3 | Aufbereitung erfolgreich abgeschlossen; noch nicht gedruckt |
| 5 | Avis aufbereitet und gedruckt |
| 6 | WBS und DLS aufbereitet; WBS gedruckt |
| 7 | Geschenkbons aufbereitet und gedruckt |
| 8 | WBS und DLS aufbereitet; DLS gedruckt |
| 9 | WBS und DLS aufbereitet; WBS und DLS gedruckt |
| X | Job erledigt; keine ausstehenden WBS / GB / Avis gefunden |</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="aufbereiten" tabindex="-1"><a class="header-anchor" href="#aufbereiten"><span>Aufbereiten</span></a></h3>
<p>Startet die Aufbereitung und druckt das Protokoll. Siehe <RouteLink to="/referenz/refs/ft.refproc.faktavis.html" title="Fakturen/Avis-Aufbereitung starten">Fakturen/Avis-Aufbereitung starten</RouteLink>.</p>
<h3 id="aufbereitete-wbs-drucken" tabindex="-1"><a class="header-anchor" href="#aufbereitete-wbs-drucken"><span>Aufbereitete WBS drucken</span></a></h3>
<p>Aufbereitete Fakturen werden mit diesem Programm gedruckt. Dabei können mehrere Auftragsarten miteinander verarbeitet werden, sofern sie dasselbe Papierformat bzw. denselben Drucker verwenden. Siehe <RouteLink to="/referenz/refs/ft.refproc.wbsdrucken.html" title="Fakturen drucken, aufbereitete">Aufbereitete Fakturen/Avis drucken</RouteLink>.</p>
<h3 id="direktlieferanten-ls-drucken" tabindex="-1"><a class="header-anchor" href="#direktlieferanten-ls-drucken"><span>Direktlieferanten-LS drucken</span></a></h3>
<p>Direktlieferanten-Abwicklung wird für Aufträge benötigt, bei denen aus einem externen Lager direkt an den Kunden geliefert wird. Nebst der eigentlichen Fakturierung, bei der eine Rechnung (wie bei normalen Aufträgen auch) gedruckt wird, kann ein &quot;Auftragsformular&quot; für die Abwicklung der Aufträge zuhanden des Direktlieferanten ausgedruckt werden.</p>
<h3 id="sammelfakturen-drucken" tabindex="-1"><a class="header-anchor" href="#sammelfakturen-drucken"><span>Sammelfakturen drucken</span></a></h3>
<p>Beim Drucken der Sammelaufträge werden mehrere Abläufe parallel durchgeführt. Siehe <RouteLink to="/manual/trade/sammelfakturen.html" title="10. Sammelfakturen (mehrere Rechnungen zusammenfassen)">Sammelfakturen</RouteLink>.</p>
<h3 id="aufbereitete-avis-drucken" tabindex="-1"><a class="header-anchor" href="#aufbereitete-avis-drucken"><span>Aufbereitete Avis drucken</span></a></h3>
<p>Druckt die Avis nach Auftragsart. Siehe <RouteLink to="/manual/trade/avisierungssystem.html" title="2. Avisierungssystem">Avisierungssystem</RouteLink>.</p>
<h3 id="bereitstellungsliste-drucken" tabindex="-1"><a class="header-anchor" href="#bereitstellungsliste-drucken"><span>Bereitstellungsliste drucken</span></a></h3>
<p>Druckt eine Bereitstellungsliste (&quot;Rüstschein&quot;) für das Lager. Siehe <RouteLink to="/referenz/refs/ft.refproc.bereitstldrucken.html" title="Bereitstellungsliste drucken">Bereitstellungsliste drucken</RouteLink>.</p>
<h3 id="direktliefer-ls-kopien-drucken" tabindex="-1"><a class="header-anchor" href="#direktliefer-ls-kopien-drucken"><span>Direktliefer.-LS-Kopien drucken</span></a></h3>
<p>Druckt Kopien von aufbereiteten und gedruckten Direktlieferscheinen (siehe oben).</p>
<h3 id="sammelfakturen-kopien-drucken" tabindex="-1"><a class="header-anchor" href="#sammelfakturen-kopien-drucken"><span>Sammelfakturen-Kopien drucken</span></a></h3>
<p>Druckt Kopien von aufbereiteten und gedruckten Sammelfakturen (siehe oben).</p>
<h3 id="avis-kopien-drucken" tabindex="-1"><a class="header-anchor" href="#avis-kopien-drucken"><span>Avis-Kopien drucken</span></a></h3>
<p>Druckt Kopien von aufbereiteten und gedruckten Avis (siehe oben).</p>
<h3 id="protokoll-drucken" tabindex="-1"><a class="header-anchor" href="#protokoll-drucken"><span>Protokoll drucken</span></a></h3>
<p>Druckt die Aufbereitungsprotokolle nach Jobdatum (von/bis).</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.faktavis.html" title="Fakturen/Avis-Aufbereitung starten">Fakturen/Avis-Aufbereitung starten</RouteLink></p>
</div></template>


